import React from 'react'
import { Popover, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import ButtonBase from '@mui/material/ButtonBase'

import { ReactComponent as Info } from '@mike/mike-shared-frontend/media/icons/Info'
import { iconPrimaryStyle } from '../buttons/iconStyles'

const StyledPopover = styled(Popover)({
  maxWidth: '75vw'
})

const StyledContent = styled('div')(({ theme }) => ({
  padding: theme.spacing(2)
}))

interface IProps {
  helpTexts: string[]
  disabled?: boolean
}

const ContextHelp = (props: IProps) => {
  const { helpTexts, disabled } = props

  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    event.stopPropagation()
    !disabled && setAnchorEl(event.currentTarget)
  }

  const handleClose = event => {
    event.stopPropagation()
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'context-help' : undefined

  return (
    <>
      <ButtonBase
        sx={{ cursor: disabled ? 'default' : 'pointer' }}
        aria-describedby={id}
        onClick={handleClick}
      >
        <Info className={iconPrimaryStyle(disabled)} />
      </ButtonBase>
      <StyledPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <StyledContent>
          {helpTexts.map((helpText, index) => {
            return <Typography key={index}>{helpText}</Typography>
          })}
        </StyledContent>
      </StyledPopover>
    </>
  )
}

export default ContextHelp
